goog.provide("shadow.js.shim.module$src$svg$artwork$retro_tv_svg");
goog.provide("module$shadow_js_shim_module$src$svg$artwork$retro_tv_svg");
shadow.js.shim.module$src$svg$artwork$retro_tv_svg = shadow.js.nativeProvides["src/svg/artwork/retro-tv.svg"] = shadow$bridge("src/svg/artwork/retro-tv.svg");
module$shadow_js_shim_module$src$svg$artwork$retro_tv_svg.default = shadow.js.shim.module$src$svg$artwork$retro_tv_svg;
